// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import common from './util/common'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import "swiper/dist/css/swiper.css";
import "@/util/utils.js"
import "@/util/TCaptcha.js";//腾讯防水墙js代码

Vue.use(ElementUI);
Vue.use(common);
Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false;

Vue.prototype.HOST = process.env.API_ROOT;
Vue.prototype.CLUB_ROOT = process.env.CLUB_ROOT;
Vue.prototype.CLUB_USERCENTER = process.env.CLUB_USERCENTER;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js